<script>
	import LegalDocument from '$lib/components/LegalDocument.svelte';
	import termsMd from './terms.md?raw';
</script>

<LegalDocument title="이용약관" content={termsMd} />
